import { useState } from "react";

const DEFAULT_TECHNICAL_SKILLS = [
  "Business Productivity Tools (Excel, Word, PowerPoint, and basic office software)",
  "Software & Web Development Coding, scripting, or building digital products (Python, etc)",
  "Planning & Project Oversight (Managing timelines, budgets, and teams to hit goals)",
  "Technical Repair & Machinery (Hands-on maintenance of vehicles, medical gear, or hardware)",
  "Supply Chain & Stock Control (Tracking materials, retail inventory, or warehouse logistics)",
  "Engineering & Design Software (Using 2D/3D tools for architecture, parts, or product design)",
  "Digital Operations & Routing (Managing delivery systems, fleet tracking, or e-commerce flows)",
  "Data Entry & Financial Records (Processing payments, managing databases, or bookkeeping)",
];

export default function TechnicalSkillsSelector({ form, updateField }) {
  const selected = Array.isArray(form.Technical_Skills) ? form.Technical_Skills : [];

  const [adding, setAdding] = useState(false);
  const [custom, setCustom] = useState("");
  const [message, setMessage] = useState("");

  const setMsg = (txt) => {
    setMessage(txt);
    if (txt) setTimeout(() => setMessage(""), 1800);
  };

  const toggle = (value) => {
    const exists = selected.includes(value);

    if (!exists && selected.length >= 3) {
      setMsg("You can select up to 3 technical skills only");
      return;
    }

    const updated = exists
      ? selected.filter((v) => v !== value)
      : [...selected, value];

    updateField("Technical_Skills", updated);
    setMsg("Saved successfully ✅");
  };

  const addCustom = () => {
    const value = custom.trim();
    if (!value) return setMsg("Please enter a technical skill");
    if (selected.includes(value)) return setMsg("Skill already added");
    if (selected.length >= 3) return setMsg("You can select up to 3 technical skills only");

    updateField("Technical_Skills", [...selected, value]);
    setCustom("");
    setAdding(false);
    setMsg("Saved successfully ✅");
  };

  return (
    <div className="rounded-xl border border-pink-400/20 bg-white/5 p-4">
      <div className="flex items-center justify-between gap-3 mb-3">
        <p className="text-pink-300 text-sm font-semibold">
          Select your top 3 Technical Skills
        </p>

        <span className="text-xs text-white/60 whitespace-nowrap">
          {selected.length}/3 selected
        </span>
      </div>

      {/* ✅ ONLY this list scrolls */}
      <div className="max-h-[40vh] overflow-y-auto pr-2">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2">
          {DEFAULT_TECHNICAL_SKILLS.map((skill) => (
            <label
              key={skill}
              className="min-w-0 flex items-start gap-2 text-[13px] sm:text-sm text-white/85 leading-snug cursor-pointer hover:text-white"
            >
              <input
                type="checkbox"
                className="mt-1 accent-pink-500 flex-shrink-0"
                checked={selected.includes(skill)}
                onChange={() => toggle(skill)}
              />
              <span className="min-w-0 whitespace-normal break-words">
                {skill}
              </span>
            </label>
          ))}
        </div>
      </div>

      {/* ✅ Add custom */}
      {!adding && (
        <button
          className="text-pink-400 text-sm underline mt-3"
          onClick={() => {
            if (selected.length >= 3) return setMsg("You already selected 3 skills");
            setAdding(true);
            setMessage("");
          }}
        >
          + Add Technical Skill
        </button>
      )}

      {adding && (
        <div className="mt-3">
          <input
            value={custom}
            onChange={(e) => setCustom(e.target.value)}
            placeholder="Enter technical skill"
            className="w-full px-3 py-2 bg-[#11111a] border border-pink-400/40 rounded text-sm"
          />

          <div className="flex gap-2 mt-2">
            <button
              onClick={addCustom}
              className="bg-pink-500 px-3 py-1 rounded text-black text-sm"
            >
              Add
            </button>

            <button
              onClick={() => {
                setAdding(false);
                setCustom("");
                setMessage("");
              }}
              className="bg-gray-600 px-3 py-1 rounded text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* ✅ Message */}
      {message && (
        <p className={`text-sm mt-2 ${message.includes("Saved") ? "text-green-400" : "text-red-400"}`}>
          {message}
        </p>
      )}
    </div>
  );
}